import React, { ReactNode } from 'react';

import cx from 'classnames';

import styles from './InputHelperText.module.scss';
import { INPUT_ERROR_MESSAGE } from '../../../constants';

interface IInputHelperTextProps {
	children: ReactNode;
	className?: string;
	error?: boolean;
}

const InputHelperText = (props: IInputHelperTextProps) => {
	const { children, className, error } = props;

	return (
		<div
			className={cx(
				styles.helperContainer,
				{
					[styles.error]: error,
				},
				className,
			)}
			data-id={INPUT_ERROR_MESSAGE}
		>
			{children}
		</div>
	);
};

export default InputHelperText;
